var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChloratornoStopanstvoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.54,13.36c-0.02-0.79,0-9.09,0-9.09h-6.97c0,0,0.06,7.93,0,9.09c-4.23,1.4-7.19,5.32-7.19,10.02 C6.38,29.24,11.13,34,17,34c5.87,0,10.62-4.76,10.62-10.62C27.62,18.72,24.71,14.79,20.54,13.36z M14.27,30.48 c-2.41,0-3.95-2.08-3.95-4.26c0-2.12,1.58-3.95,3.95-3.95c2.33,0,3.04,1.52,3.04,1.52L16.4,24.7c0,0-0.61-0.91-1.82-0.91 c-1.75,0-2.74,1.13-2.74,2.43c0,1.3,0.78,2.74,2.43,2.74c1.65,0,2.43-1.22,2.43-1.22l0.91,0.91 C17.61,28.65,16.68,30.48,14.27,30.48z M19.75,29.88h-1.22v-7.61h1.22V29.88z M15.39,18.51c-3.18-0.09-5.07,1.14-6.37,3.33 c0-3.46,2.58-5.72,6.37-6.97c0.05-1.04,0-8.79,0-8.79h3.64c0,0-0.02,8.08,0,8.79c3.74,1.28,6.37,4.12,6.37,7.88 C19.95,23.28,20.64,18.66,15.39,18.51z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2,
    className: "st0",
    width: 9.79,
    height: 2.75
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChloratornoStopanstvoIcon);
export default __webpack_public_path__ + "static/media/chloratorno_stopanstvo_icon.82ab2a6a.svg";
export { ForwardRef as ReactComponent };